/* Reglintz startsida: lägg i varukorg, filter, rutinguide (laddas som modul) */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  if (window.__rgInit) return;
  window.__rgInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var c = Math.round(cents), ore = c % 100;
    var hel = String((c - ore) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return hel + (ore ? ',' + (ore < 10 ? '0' : '') + ore : '') + ' kr';
  }

  function toast(text) {
    var t = document.querySelector('.rg-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'rg-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span>' + text + '</span><a href="' + root + 'cart">Till varukorgen</a>';
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  function cartRoutes() {
    var r = (window.Theme && window.Theme.routes) || {};
    return { add: r.cart_add_url || root + 'cart/add.js', cart: (r.cart_url || root + 'cart') + '.js' };
  }

  function drawerWillOpen() {
    return !!document.querySelector('cart-drawer-component[auto-open]');
  }

  // Lägger till i varukorgen och meddelar temats varukorg (Horizon) så att ikon och låda uppdateras.
  function addToCart(items, sourceEl) {
    var routes = cartRoutes();
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) {
      return el.dataset.sectionId;
    }).filter(Boolean);

    var ev = { CartLinesUpdateEvent: CartLinesUpdateEvent };
    return Promise.resolve().then(function () {
      var deferred = ev.CartLinesUpdateEvent && ev.CartLinesUpdateEvent.createPromise ? ev.CartLinesUpdateEvent.createPromise() : null;
      if (deferred) {
        (sourceEl || document).dispatchEvent(new ev.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
          promise: deferred.promise
        }));
      }
      var ok = true;
      var addJson;
      return fetch(routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionIds.join(',') })
      }).then(function (r) { ok = r.ok; return r.json(); })
        .then(function (json) {
          addJson = json;
          return fetch(routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (deferred) {
            deferred.resolve({
              cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'reglintz-home',
                sourceId: 'reglintz-home',
                itemCount: items.reduce(function (n, i) { return n + i.quantity; }, 0),
                sections: ok ? addJson.sections : undefined,
                didError: !ok
              }
            });
          }
          if (!ok) throw new Error(addJson.description || addJson.message || 'Kunde inte lägga till');
          return cart;
        })
        .catch(function (err) {
          if (deferred) deferred.reject(err);
          throw err;
        });
    });
  }

  // Snabbköp på produktkort
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rg-add]');
    if (!btn) return;
    e.preventDefault();
    var icon = /__plus|pc__q/.test(btn.className);
    var label = icon ? btn.innerHTML : btn.textContent;
    btn.disabled = true;
    if (icon) { btn.classList.add('is-busy'); btn.textContent = '…'; } else { btn.textContent = 'Lägger till…'; }
    var rgLev = btn.getAttribute('data-rg-lev');
    var rgItem = { id: Number(btn.getAttribute('data-rg-add')), quantity: 1 };
    if (rgLev) rgItem.properties = { Leverans: rgLev };
    addToCart([rgItem], btn)
      .then(function () {
        if (!drawerWillOpen()) toast('Tillagd i varukorgen ✓');
        if (icon) { btn.textContent = '✓'; btn.classList.add('is-klar'); }
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () {
        btn.classList.remove('is-busy');
        if (icon) {
          setTimeout(function () { btn.innerHTML = label; btn.disabled = false; btn.classList.remove('is-klar'); }, 1600);
        } else { btn.disabled = false; btn.textContent = label; }
      });
  });

  // Underkategorier och produkttyp-knappar: byt produkter utan att hoppa till toppen
  var rgSoftNav = false;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.rg-sub__kort, a.rg-typ');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (!window.fetch || !window.history || !history.pushState || !window.DOMParser) return;
    var main = document.querySelector('main');
    if (!main) return;
    e.preventDefault();
    var rad = document.querySelector('.rg-sub__rad');
    var radX = rad ? rad.scrollLeft : 0;
    var y = window.scrollY;
    main.setAttribute('aria-busy', 'true');
    main.style.opacity = '.55';
    fetch(a.href, { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nmain = doc.querySelector('main');
        if (!nmain) throw new Error('no main');
        // Adressen måste bytas FÖRE innehållet: produktlistan läser adressen när den startar
        // och hämtar annars "nästa sida" från den förra kategorin.
        history.pushState({ rgSoft: true }, '', a.href);
        document.title = doc.title;
        main.innerHTML = nmain.innerHTML;
        rgSoftNav = true;
        var nrad = document.querySelector('.rg-sub__rad');
        if (nrad) nrad.scrollLeft = radX;
        window.scrollTo(0, y);
        document.dispatchEvent(new CustomEvent('rg:soft-nav'));
      })
      .catch(function () { window.location.href = a.href; })
      .finally(function () { main.removeAttribute('aria-busy'); main.style.opacity = ''; });
  });
  window.addEventListener('popstate', function () { if (rgSoftNav) window.location.reload(); });

  // Presentkort: välj belopp
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.rg-gc__chip');
    if (!c) return;
    var wrap = c.closest('[data-rg-gc]');
    wrap.querySelectorAll('.rg-gc__chip').forEach(function (x) {
      var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var b = wrap.querySelector('[data-rg-gc-belopp]');
    if (b) { b.textContent = c.getAttribute('data-belopp') + ' kr'; b.classList.add('is-puls'); setTimeout(function () { b.classList.remove('is-puls'); }, 250); }
    var k = wrap.querySelector('[data-rg-gc-kop]');
    if (k && c.getAttribute('data-url')) k.href = c.getAttribute('data-url');
  });

  // Kampanj: kopiera rabattkod
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rg-copy]');
    if (!b) return;
    var code = b.getAttribute('data-rg-copy');
    var label = b.querySelector('[data-rg-copy-label]');
    function done(t) { if (label) { label.textContent = t; setTimeout(function () { label.textContent = 'Kopiera'; }, 2500); } }
    try {
      navigator.clipboard.writeText(code).then(function () { done('Kopierad ✓'); }, function () { done('Koden: ' + code); });
    } catch (err) { done('Koden: ' + code); }
  });

  // Kampanj: nedräkning
  function initCountdown() {
    document.querySelectorAll('[data-rg-countdown]').forEach(function (el) {
      if (el._rg) return; el._rg = true;
      var end = new Date(el.getAttribute('data-rg-countdown').replace(' ', 'T'));
      var out = el.querySelector('[data-rg-cd]');
      if (isNaN(end)) { el.hidden = true; return; }
      function tick() {
        var ms = end - new Date();
        if (ms <= 0) { el.querySelector('span').textContent = ''; out.textContent = el.getAttribute('data-rg-ended'); return; }
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
        out.textContent = (d ? d + ' d ' : '') + h + ' h ' + String(m).padStart(2, '0') + ' min ' + String(s).padStart(2, '0') + ' s';
        setTimeout(tick, 1000);
      }
      tick();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCountdown); else initCountdown();
  document.addEventListener('shopify:section:load', initCountdown);

  // Köp igen: byt rutin
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-rg-rutin-tab]');
    if (!tab) return;
    var wrap = tab.closest('[data-rg-routine]');
    wrap.querySelectorAll('[data-rg-rutin-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  });

  // Rebeckas rutiner: välj nyans direkt i listan
  function rgRutinSumma(panel) {
    var alla = panel.querySelector('.rg-again__alla');
    if (!alla) return;
    var items = [], total = 0, saknar = 0;
    panel.querySelectorAll('.rg-again__rad').forEach(function (rad) {
      var plus = rad.querySelector('.rg-again__plus');
      if (!plus) return;
      if (!plus.hasAttribute('data-rg-add')) { saknar++; return; }
      var it = { id: Number(plus.getAttribute('data-rg-add')), quantity: 1 };
      var lev = plus.getAttribute('data-rg-lev');
      if (lev) it.properties = { Leverans: lev };
      items.push(it);
      total += Number(plus.getAttribute('data-rg-p') || 0);
    });
    var btn = alla.querySelector('[data-rg-add-all]');
    btn.setAttribute('data-rg-add-all', JSON.stringify(items));
    btn.textContent = (saknar ? 'Lägg ' + items.length + ' produkter i varukorgen' : 'Lägg hela rutinen i varukorgen') + ' · ' + money(total);
    alla.hidden = items.length < 2;
    var fs = Number(alla.getAttribute('data-rg-fs') || 0);
    var frakt = alla.querySelector('[data-rg-frakt]');
    if (frakt && fs > 0) frakt.textContent = total >= fs ? 'Fri frakt ingår' : money(fs - total) + ' kvar till fri frakt';
    var not = panel.querySelector('[data-rg-nyans-not]');
    if (not) {
      not.hidden = !saknar;
      not.textContent = 'Välj nyans så kommer ' + (saknar === 1 ? 'produkten' : 'produkterna') + ' med när du lägger allt i varukorgen.';
    }
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-rg-sw]');
    if (!sw || sw.disabled) return;
    var rad = sw.closest('.rg-again__rad');
    if (!rad) return;
    rad.querySelectorAll('[data-rg-sw]').forEach(function (x) {
      var on = x === sw; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var namn = sw.getAttribute('data-t');
    var plus = rad.querySelector('[data-rg-nyans-plus]');
    if (plus) {
      plus.disabled = false;
      plus.setAttribute('data-rg-add', sw.getAttribute('data-rg-sw'));
      plus.setAttribute('data-rg-lev', sw.getAttribute('data-lev') || '');
      plus.setAttribute('data-rg-p', sw.getAttribute('data-p'));
      plus.setAttribute('aria-label', 'Lägg ' + plus.getAttribute('data-rg-namn') + ', ' + namn + ' i varukorgen');
    }
    var txt = rad.querySelector('.rg-sw-namn');
    if (txt) { txt.textContent = 'Vald nyans: '; var s = document.createElement('strong'); s.textContent = namn; txt.appendChild(s); }
    var pris = rad.querySelector('[data-rg-pris-txt]');
    if (pris && sw.getAttribute('data-ptxt')) pris.textContent = sw.getAttribute('data-ptxt');
    var url = sw.getAttribute('data-url');
    if (url) rad.querySelectorAll('.rg-again__bild, .rg-again__info a').forEach(function (a) { a.href = url; });
    var bild = sw.getAttribute('data-img');
    var img = rad.querySelector('.rg-again__bild img');
    if (bild && img) { img.removeAttribute('srcset'); img.src = bild; }
    var panel = rad.closest('.rg-again__panel');
    if (panel) rgRutinSumma(panel);
  });

  // Köp igen: lägg hela rutinen i varukorgen
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rg-add-all]');
    if (!btn) return;
    e.preventDefault();
    var items;
    try { items = JSON.parse(btn.getAttribute('data-rg-add-all')); } catch (err) { return; }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Lägger till…';
    addToCart(items, btn)
      .then(function () { if (!drawerWillOpen()) toast('Rutinen ligger i varukorgen ✓'); })
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });

  // Bästsäljare: visa ett slumpat urval bland de mest sålda
  function shuffleProducts() {
    document.querySelectorAll('[data-rg-products][data-shuffle]').forEach(function (wrap) {
      if (wrap._rgMixed) return; wrap._rgMixed = true;
      var grid = wrap.querySelector('.rg-products');
      if (!grid) return;
      var pool = Number(wrap.getAttribute('data-shuffle') || 16);
      function lista(attr) { return (wrap.getAttribute(attr) || '').split(',').filter(Boolean); }
      function handle(c) { var a = c.querySelector('a[href*="/products/"]'); var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
      var fastH = lista('data-rg-fast'), rotH = lista('data-rg-rotera');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.rg-card'));
      // Fasta produkter först, sedan en slumpad av de roterande, sedan de blandade bästsäljarna. Övriga roterande sist.
      var fast = cards.filter(function (c) { return fastH.indexOf(handle(c)) > -1; });
      var rot = cards.filter(function (c) { return rotH.indexOf(handle(c)) > -1 && fast.indexOf(c) < 0; });
      var ovriga = cards.filter(function (c) { return fast.indexOf(c) < 0 && rot.indexOf(c) < 0; });
      var head = ovriga.slice(0, pool), rest = ovriga.slice(pool);
      for (var i = head.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = head[i]; head[i] = head[j]; head[j] = t; }
      var vald = rot.length ? rot.splice(Math.floor(Math.random() * rot.length), 1) : [];
      fast.concat(vald, head, rest, rot).forEach(function (c) { grid.appendChild(c); });
      var on = wrap.querySelector('[data-rg-chip].is-on') || wrap.querySelector('[data-rg-chip="*"]');
      if (on) on.click(); else {
        var max = Number(wrap.getAttribute('data-max') || 8), n = 0;
        grid.querySelectorAll('.rg-card').forEach(function (c) { c.hidden = n >= max; n++; });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shuffleProducts); else setTimeout(shuffleProducts, 0);
  document.addEventListener('shopify:section:load', shuffleProducts);

  // Filterknappar för bästsäljare
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-rg-chip]');
    if (!chip) return;
    var wrap = chip.closest('[data-rg-products]');
    var cat = chip.getAttribute('data-rg-chip');
    // Under "Alla" visas det inställda antalet, under en filterknapp får fler plats (t.ex. alla dofter).
    var max = Number(wrap.getAttribute('data-max') || 8) + (cat === '*' ? 0 : 4);
    wrap.querySelectorAll('[data-rg-chip]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
    var shown = 0;
    wrap.querySelectorAll('.rg-card').forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split('|');
      var match = cat === '*' || cats.indexOf(cat) > -1;
      var show = match && shown < max;
      card.hidden = !show;
      if (show) shown++;
    });
  });

  // Rutinguide
  function initQuiz(box) {
    var dataEl = box.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var stage = box.querySelector('[data-rg-stage]');
    var ans = [];
    // Fråga 2 beror på svaret i fråga 1: visa bara tillägg som hör till det valda svaret.
    function questions() {
      var qs = [{ q: data.q1, opts: data.focus || [] }];
      if (ans.length) {
        var chosen = ans[0];
        var opts = (data.extra || []).filter(function (o) {
          return !o.for || !o.for.length || o.for.indexOf(chosen.label) > -1;
        });
        if (opts.length) qs.push({ q: chosen.q2 || data.q2, opts: opts });
      } else if ((data.extra || []).length) {
        qs.push({ q: data.q2, opts: [] });
      }
      return qs;
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function render() {
      var qs = questions();
      if (ans.length < qs.length) {
        var s = qs[ans.length];
        var pct = ((ans.length + 1) / (qs.length + 1)) * 100;
        stage.innerHTML =
          '<div class="rg-qstep">Fråga ' + (ans.length + 1) + ' av ' + qs.length + '</div>' +
          '<div class="rg-qbar"><i style="width:' + pct + '%"></i></div>' +
          '<div class="rg-qq">' + esc(s.q) + '</div>' +
          '<div class="rg-qopts">' + s.opts.map(function (o, i) {
            return '<button type="button" class="rg-qopt" data-i="' + i + '">' + esc(o.label) + '<small>' + esc(o.sub || '') + '</small></button>';
          }).join('') + '</div>';
        stage.querySelectorAll('.rg-qopt').forEach(function (b) {
          b.addEventListener('click', function () { ans.push(s.opts[Number(b.getAttribute('data-i'))]); render(); });
        });
        return;
      }
      var items = [], seenV = {}, grupper = [];
      ans.forEach(function (a, gi) {
        var g = [];
        (a.products || []).forEach(function (p) { if (p && p.available && !seenV[p.variant]) { seenV[p.variant] = 1; items.push(p); g.push(p); } });
        if (g.length) grupper.push({ rubrik: gi === 0 ? (a.rubrik || 'Grundrutin för ' + a.label.toLowerCase()) : 'För ' + a.label.toLowerCase(), produkter: g, grund: gi === 0 });
      });
      // Det kunden valde i fråga 2 visas först, grundrutinen efter.
      grupper.sort(function (a, b) { return a.grund - b.grund; });
      // Produkter med nyanser: kunden väljer nyans direkt i resultatet.
      function rita() {
        var direkt = items.filter(function (p) { return !p.nyans || p.valt; });
        var saknar = items.length - direkt.length;
        var total = direkt.reduce(function (t, p) { return t + p.price; }, 0);
        var left = data.free_shipping * 100 - total;
        var knapp = saknar ? 'Lägg ' + direkt.length + ' produkter i korgen' : 'Lägg allt i korgen';
        stage.innerHTML =
          '<div class="rg-qstep">Din rutin · ' + esc(ans.map(function (a) { return a.label; }).join(' · ')) + '</div>' +
          '<div class="rg-qbar"><i style="width:100%"></i></div>' +
          '<div class="rg-qq">' + esc(data.result_heading) + '</div>' +
          '<div class="rg-qres">' +
          (items.length ? grupper.map(function (g) {
            return (grupper.length > 1 ? '<div class="rg-qres__grupp">' + esc(g.rubrik) + '</div>' : '') + g.produkter.map(function (p) {
              var k = items.indexOf(p);
              var pris = p.pct ? '<span class="rg-kp rg-kp--mini"><span class="rg-kp__pris">' + money(p.price) + '</span><span class="rg-kp__etikett">−' + p.pct + '&nbsp;%</span></span>' : money(p.price);
              var plus = '<button type="button" class="rg-qres__plus"' + (p.nyans && !p.valt ? ' disabled aria-label="Välj nyans först"' : ' data-rg-add="' + p.variant + '"' + (p.lev ? ' data-rg-lev="' + esc(p.lev) + '"' : '') + ' aria-label="Lägg ' + esc(p.title) + ' i varukorgen"') + '>+</button>';
              var val = p.nyans && p.varianter && p.varianter.length ? '<div class="rg-nyansrad"><div class="rg-swatchar" role="group" aria-label="Välj nyans för ' + esc(p.title) + '">' +
                p.varianter.map(function (v) {
                  var on = p.valt && p.valt.id === v.id;
                  return '<button type="button" class="rg-sw' + (on ? ' is-on' : '') + (v.img ? '' : ' rg-sw--text') + '" data-k="' + k + '" data-v="' + v.id + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + esc(v.t) + (v.a ? '' : ' – slut') + '" title="' + esc(v.t) + '"' + (v.a ? '' : ' disabled') + '>' + (v.img ? '<img src="' + v.img + '" alt="" loading="lazy">' : esc(v.t)) + '</button>';
                }).join('') + '</div><div class="rg-sw-namn">' + (p.valt ? 'Vald nyans: <strong>' + esc(p.valt.t) + '</strong>' : 'Välj nyans') + '</div></div>' : '';
              var bild = p.valt && p.valt.img ? p.valt.img : p.image;
              return '<div class="rg-qres__it' + (val ? ' rg-qres__it--nyans' : '') + '"><a class="rg-qres__lank" href="' + p.url + '"><div class="rg-qres__th">' + (bild ? '<img src="' + bild + '" alt="" loading="lazy">' : '') + '</div><div><b>' + esc(p.title) + '</b><span>' + esc(p.vendor) + ' · ' + pris + '</span></div></a>' + plus + val + '</div>';
            }).join('');
          }).join('') : '<p>Produkterna är tyvärr slut just nu – fråga oss i salongen!</p>') +
          (saknar ? '<p class="rg-nyans-not">Välj nyans så kommer ' + (saknar === 1 ? 'produkten' : 'produkterna') + ' med när du lägger allt i korgen.</p>' : '') +
          (direkt.length > 1 ? '<div class="rg-qres__tot"><span>Totalt <b>' + money(total) + '</b> ' + (left <= 0 ? '· fri frakt ✓' : '· ' + money(left) + ' kvar till fri frakt') + '</span><button type="button" class="rg-btn rg-btn--dark" data-rg-addall style="padding:11px 20px">' + knapp + '</button></div>' : '') +
          '<button type="button" class="rg-qredo">Gör om</button></div>';
        stage.querySelector('.rg-qredo').addEventListener('click', function () { ans = []; render(); });
        stage.querySelectorAll('.rg-sw[data-k]').forEach(function (b) {
          b.addEventListener('click', function () {
            var k = b.getAttribute('data-k'), id = b.getAttribute('data-v');
            var p = items[Number(k)];
            var v = null;
            (p.varianter || []).forEach(function (x) { if (String(x.id) === id) v = x; });
            if (!v) return;
            p.valt = v; p.variant = v.id; p.lev = v.lev; p.price = v.p;
            rita();
            var ny = stage.querySelector('.rg-sw[data-k="' + k + '"][data-v="' + id + '"]');
            if (ny) ny.focus();
          });
        });
        var all = stage.querySelector('[data-rg-addall]');
        if (all) all.addEventListener('click', function () {
          all.disabled = true; all.textContent = 'Lägger till…';
          addToCart(direkt.map(function (p) { var it = { id: p.variant, quantity: 1 }; if (p.lev) it.properties = { Leverans: p.lev }; return it; }), all)
            .then(function () { all.textContent = 'Tillagt ✓'; if (!drawerWillOpen()) toast(direkt.length + ' produkter tillagda i varukorgen ✓'); })
            .catch(function (err) { all.disabled = false; all.textContent = knapp; toast(err.message); });
        });
      }
      rita();
    }
    render();
  }

  function boot() { document.querySelectorAll('[data-rg-quiz]').forEach(initQuiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-rg-quiz]').forEach(initQuiz);
  });
})();
